(function () {
  function enhanceKnowledgeBase(root) {
    if (!root || root.dataset.kbEnhanced === 'true') return;
    root.dataset.kbEnhanced = 'true';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealItems = root.querySelectorAll('[data-kb-reveal]');

    if (!reduceMotion && 'IntersectionObserver' in window && revealItems.length) {
      root.classList.add('js-kb-ready');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealItems.forEach(function (item) { observer.observe(item); });
    }

    root.querySelectorAll('.gg-kb__prose strong').forEach(function (label) {
      var text = label.textContent.trim().toLowerCase();
      var parent = label.closest('p');
      if (!parent) return;
      if (text.indexOf('manufacturer specification') !== -1) {
        parent.classList.add('gg-kb-source-badge', 'gg-kb-source-badge--manufacturer');
      }
      if (text.indexOf('grid getaway electrical analysis') !== -1) {
        parent.classList.add('gg-kb-source-badge', 'gg-kb-source-badge--analysis');
      }
    });

    root.querySelectorAll('.gg-kb__prose table').forEach(function (table, index) {
      table.setAttribute('tabindex', '0');
      table.setAttribute('role', 'region');
      if (!table.getAttribute('aria-label')) {
        table.setAttribute('aria-label', 'Scrollable technical table ' + (index + 1));
      }
    });
  }

  function init() {
    document.querySelectorAll('.gg-kb').forEach(enhanceKnowledgeBase);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();

